import React from 'react';
import {RenderHtml, Button, Catalog, Loading} from 'components';
import { A } from 'components/styled';
import FeaturedSection from 'components/Featured/FeaturedSection';
import FeaturedEvent from "components/Featured/FeaturedEvent";
import FeaturedStory from "components/Featured/FeaturedStory";
import FeaturedEntity from "components/Featured/FeaturedEntity";

const Home = ({
  data, allPublicationsUrl, loadingState = {}
}) => {
  const bottomSectionHtml = data?.bottom_section?.content || '';
  const totalItems = data?.total_items;
  const featuredSection = data?.featured_section;
  const items = data?.items || [];
  const events = data?.events || [];
  const stories = data?.stories || [];
  const entities = data?.entities || [];

  // Destructure loading states
  const { 
    meta: metaLoading = false,
    featuredSection: featuredSectionLoading = false,
    items: itemsLoading = false,
    events: eventsLoading = false,
    stories: storiesLoading = false,
    entities: entitiesLoading = false
  } = loadingState;

  // Helper component for section loading state
  const SectionLoading = () => (
    <div className="section-loading" style={{ 
      padding: '40px', 
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '200px',
      width: '100%',
      position: 'relative'
    }}>
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
      }}>
        <Loading center size={60} />
      </div>
    </div>
  );

  return (
    <div className="Home">
      <div className="all-editions-container">
        <h1 className="header">
          Browse {metaLoading ? '...' : (totalItems ? totalItems.toLocaleString() : '...')} art books and editions
        </h1>
        <div className="all-editions-button">
          <A href={allPublicationsUrl} noUnderline><Button roundSmall small inverted wider bold>Show all editions</Button></A>
        </div>
      </div>

      {featuredSectionLoading ? (
        <SectionLoading />
      ) : (
        featuredSection && <FeaturedSection className="featured-section" featured_section={featuredSection} />
      )}

      <div className="catalog">
        {itemsLoading ? (
          <SectionLoading />
        ) : (
          <Catalog items={items} />
        )}
      </div>

      {eventsLoading ? (
        <div className="events">
          <h3>Events</h3>
          <SectionLoading />
        </div>
      ) : (
        events && events.length > 0 && (
          <div className="events">
            <h3>Events</h3>
            <div className="featured-section">
              {events.map((event, index) => (
                <FeaturedEvent key={`event-${index}`} event={event} />
              ))}
            </div>
          </div>
        )
      )}

      {storiesLoading ? (
        <div className="stories">
          <h3>Stories</h3>
          <SectionLoading />
        </div>
      ) : (
        stories && stories.length > 0 && (
          <div className="stories">
            <h3>Stories</h3>
            <div className="featured-section">
              {stories.map((story, index) => (
                <FeaturedStory key={`story-${index}`} story={story} />
              ))}
            </div>
          </div>
        )
      )}

      {entitiesLoading ? (
        <div className="entities">
          <h3>Artists & Publishers</h3>
          <SectionLoading />
        </div>
      ) : (
        entities && entities.length > 0 && (
          <div className="entities">
            <h3>Artists & Publishers</h3>
            <div className="featured-section">
              {entities.map((entity, index) => (
                <FeaturedEntity key={`entity-${index}`} entity={entity} />
              ))}
            </div>
          </div>
        )
      )}

      <div className="bottom-section">
        {metaLoading ? (
          <SectionLoading />
        ) : (
          <RenderHtml html={bottomSectionHtml} />
        )}
      </div>
    </div>
  );
}

export default Home;
